import React from 'react';

const SettingsColumnContext = React.createContext(false);

/**
 * Marks content as sitting in the new-settings column, so the legacy settings
 * rows a page still renders can take the column's card styling. Pages on the
 * old layout never render inside it, so they keep their look.
 */
export const SettingsColumnProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <SettingsColumnContext.Provider value>
    {children}
  </SettingsColumnContext.Provider>
);

export const useIsInSettingsColumn = () =>
  React.useContext(SettingsColumnContext);
